import React, { useState } from 'react';
import {
  Collapse,
  FormControlLabel,
  IconButton,
  Switch,
  Typography,
} from '@mui/material';
import { Cancel, Settings } from '@mui/icons-material';
import { LightTooltip } from '../../../../../lib/designSystem/WhiteTooltip';
import NotificationParametersConfiguration from '../NotificationParametersConfiguration';

const NotificationType = (props: any) => {
  const { notifications, setNotifications, type } = props;
  const typeNotifications = notifications.filter(
    (notification: any) => notification.type === type,
  );

  const handleChangeSwitch = (id: any) => {
    const newNotifications = notifications.map((notification: any) => {
      if (notification.id === id) {
        return { ...notification, active: !notification.active };
      }
      return notification;
    });
    setNotifications(newNotifications);
  };
  return (
    <div style={{ padding: '12px 0px' }}>
      {typeNotifications.map((notification: any) => {
        const [openParamsConfig, setOpenParamsConfig] = useState(false);
        return (
          <div style={{ padding: '8px 0px' }} key={notification.id}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              key={notification.id}
            >
              <div key={notification.id}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body1" fontWeight={'bold'}>
                    {notification.name}
                  </Typography>
                  <div>
                    <LightTooltip
                      title={
                        <Typography variant="body1" style={{ padding: '8px' }}>
                          {notification.config.length
                            ? !notification.active
                              ? 'No se puede configurar una notificación desactivada'
                              : 'Configurar parámetros'
                            : 'Esta notificación no es configurable'}
                        </Typography>
                      }
                    >
                      <div>
                        <IconButton
                          onClick={() => setOpenParamsConfig(!openParamsConfig)}
                          disabled={
                            !(notification.config.length && notification.active)
                          }
                        >
                          {openParamsConfig ? <Cancel /> : <Settings />}
                        </IconButton>
                      </div>
                    </LightTooltip>
                  </div>
                </div>
              </div>
              <FormControlLabel
                control={
                  <Switch
                    checked={notification.active}
                    onChange={() => handleChangeSwitch(notification.id)}
                  />
                }
                label={notification.active ? 'Activado' : 'Desactivado'}
                labelPlacement="start"
              />
            </div>
            <Typography variant="body1">{notification.description}</Typography>
            <Collapse in={openParamsConfig && notification.active}>
              {notification.config.map((config: any) => (
                <NotificationParametersConfiguration
                  key={config.id}
                  notificationId={notification.id}
                  setNotifications={setNotifications}
                  config={config}
                  notifications={notifications}
                />
              ))}
            </Collapse>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationType;
